import { MeasurementSystem } from "@/types/facility"

const METERS_PER_FOOT = 0.3048

const TEMPERATURE: Record<
   MeasurementSystem,
   { unit: string; fromCelsius: (celsius: number) => number }
> = {
   [MeasurementSystem.METRIC]: {
      unit: "°C",
      fromCelsius: (celsius) => celsius,
   },
   [MeasurementSystem.IMPERIAL]: {
      unit: "°F",
      fromCelsius: (celsius) => (celsius * 9) / 5 + 32,
   },
}

const DISTANCE: Record<
   MeasurementSystem,
   { unit: string; fromFeet: (feet: number) => number }
> = {
   [MeasurementSystem.METRIC]: {
      unit: "m",
      fromFeet: (feet) => feet * METERS_PER_FOOT,
   },
   [MeasurementSystem.IMPERIAL]: { unit: "ft", fromFeet: (feet) => feet },
}

export const convertTemperature = (
   celsius: number | null | undefined,
   measurementSystem: MeasurementSystem
): number | null =>
   celsius != null ? TEMPERATURE[measurementSystem].fromCelsius(celsius) : null

export const getTemperatureUnit = (
   measurementSystem: MeasurementSystem
): string => TEMPERATURE[measurementSystem].unit

export const convertDistance = (
   feet: number | null,
   measurementSystem: MeasurementSystem
): number | null =>
   feet !== null ? DISTANCE[measurementSystem].fromFeet(feet) : null

export const getDistanceUnit = (measurementSystem: MeasurementSystem): string =>
   DISTANCE[measurementSystem].unit
